<template>
  <div>
    <b-row>
      <b-col cols="9">
        <div>
          <h2>{{ $t("checklist.pendencies.opened") }}</h2>
        </div>
        <div>
          <pendencies-export
            :fields="fields"
            :table-filters="tableFilters"
            :pagination-per-page="tablePerPage"
            :pendencyStatus="90104"
          >
          </pendencies-export>
        </div>
      </b-col>
      <b-col
        cols="3"
        style="display: flex; justify-content: flex-end; align-items: flex-end"
      >
        <base-event-timer
          :timer.sync="eventTimer"
          :lastRefreshTime="lastRefreshTime"
        ></base-event-timer>
        <!-- {{eventTimer}} -->
      </b-col>
    </b-row>

    <div v-if="isLoadingFilters">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        ref="table"
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter.sync="tableFilters"
        :filter-debounce="500"
        selectable
        :select-mode="tableSelectMode"
        @context-changed="contextChanged"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="field.key == 'action'">
                <b-form-group
                  :label="$t('geral.saveFilters')"
                  label-for="saveFilter"
                  class="labelSaveFilter"
                >
                  <b-form-checkbox
                    id="saveFilter"
                    v-model="tableFilters.saveFilter"
                    style="margin-left: 105px; margin-top: -28px"
                  ></b-form-checkbox>
                </b-form-group>
                <b-button
                  size="sm"
                  class="btn-checklist cleanFilters"
                  @click="filtersClean"
                >
                  {{ $t("geral.cleanFilters") }}
                </b-button>
              </div>
              <div>
                <div v-if="field.key == 'pendencyCreated'">
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters.pendencyCreated"
                    :dateBegin.sync="tableFilters.dateCreateBegin"
                    :dateEnd.sync="tableFilters.dateCreateEnd"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDate"
                    :filterDates="filterDateApplied"
                  ></base-filter-date>
                </div>
                <pendency-priority-dropdown
                  v-else-if="field.key == 'pendencyPriorityId'"
                  :model.sync="tableFilters[field.key]"
                  :show-zero="true"
                />
                <b-form-select
                  v-else-if="field.key == 'pendencyStatusId'"
                  :options="optionsPendencyStatus"
                  v-model="tableFilters[field.key]"
                />

                <b-form-input
                  v-else-if="tableFilters[field.key] != null"
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(checklistId)="data">
          <router-link
            v-if="module != '0'"
            :to="
              '/module/pendencies/PedenciesDetails/' +
              data.item.checklistId +
              moduleId
            "
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
          <router-link
            v-else
            :to="'/checklist/form/filled/details/' + data.item.checklistId"
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
        </template>
        <template v-slot:cell(action)="data">
          <div v-if="moduleId">
            <router-link
              v-if="data.item.approvalDate != null"
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
          <div v-else>
            <router-link
              v-if="data.item.approvalDate != null"
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
        </template>
      </b-table>
    </div>
    <div>
      <table-pagination-range
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
        @homePage="homePage"
        @prevPage="prevPage"
        @nextPage="nextPage"
      >
      </table-pagination-range>
    </div>
  </div>
</template>

<script>
import TablePaginationRange from "@/components_rms/base/TablePaginationRange.vue";
export default {
  components: {
    TablePaginationRange,
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    PendenciesExport: () =>
      import("@/pagesRms/checklist/pendency/PendenciesExport.vue"),
    PendencyPriorityDropdown: () =>
      import(
        "@/components_rms/checklist/pendency/PendencyPriorityDropdown.vue"
      ),
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  props: {
    moduleId: String,
  },
  data: function () {
    return {
      fields: [
        {
          key: "action",
          sortable: false,
          label: "",
          thStyle: "min-width: 150px",
        },
        {
          key: "id",
          filterKey: "id",
          sortable: false,
          label: "Pendência",
          thStyle: "width: 110px",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Checklist",
          thStyle: "width: 110px",
        },
        {
          key: "pendencyStatusId",
          filterKey: "pendencyStatusId",
          sortable: false,
          label: "Status",
          thStyle: "min-width: 120px",
          formatter: (value, key, item) => {
            if (value == 1) return "Não iniciada";
            if (value == 4) return "Iniciada";
            return "";
          },
        },
        {
          key: "pendencyPriorityId",
          filterKey: "pendencyPriorityId",
          sortable: false,
          label: "Prioridade",
          thStyle: "min-width: 120px",
          formatter: (value, key, item) => {
            if (value == 1) return "Alta";
            if (value == 2) return "Média";
            if (value == 3) return "Baixa";
            return "";
          },
        },
        {
          key: "formSearchKey",
          filterKey: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
          thStyle: "width: 200px",
        },
        {
          key: "formName",
          filterKey: "formName",
          sortable: false,
          label: "Formulário",
        },
        {
          key: "pendencyCreated",
          filterKey: "pendencyCreated",
          sortable: false,
          label: "Criação da pendência",
          filterType: "dateRangeCreate",
          formatter: (value, key, item) => {
            let date = new Date(item.creationDate);
            return date.toLocaleString();
          },
        },
        {
          key: "pendencyDescription",
          filterKey: "pendencyDescription",
          sortable: false,
          label: "Descrição",
        },
      ],
      tableFilters: {
        currentPage: 1,
        perPage: 10,
        id: "",
        checklistId: "",
        formName: "",
        formSearchKey: "",
        pendencyCreated: "",
        pendencyDescription: "",
        dateCreateBegin: "",
        dateCreateEnd: "",
        exportType: "",
        templateId: "",
        pendencyStatusId: 90104,
        pendencyPriorityId: 0,
        saveFilter: true,
      },
      paginationEnd: null,
      paginationEndList: [],
      tableItems: [],
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      isBusy: false,
      module: "0",
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableSelectMode: "single",
      tableSelectedItem: [],
      checklist: {},
      hasAttachments: false,
      optionsPendencyStatus: [
        { value: 90104, text: "" },
        { value: 1, text: "Não iniciada" },
        { value: 4, text: "Iniciada" },
      ],
      optionFilterDate: 0,
      refreshTime: 0,
      timer: null,
      lastRefreshTime: null,
      filterDateApplied: [],
      isLoadingFilters: false,
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
    if (this.moduleId) this.module = this.moduleId;
    this.filtersGet().then(() => {
      this.myProviderCount();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ensureFilterDefaults() {
      const defaults = {
        currentPage: 1,
        perPage: 10,
        id: "",
        checklistId: "",
        formName: "",
        formSearchKey: "",
        pendencyCreated: "",
        pendencyDescription: "",
        dateCreateBegin: "",
        dateCreateEnd: "",
        exportType: "",
        templateId: "",
        pendencyStatusId: 90104,
        pendencyPriorityId: 0,
        saveFilter: true,
      };

      Object.keys(defaults).forEach((key) => {
        if (this.tableFilters[key] == null) {
          this.$set(this.tableFilters, key, defaults[key]);
        }
      });
    },
    filtersClean() {
      this.tableFilters = {
        currentPage: 1,
        perPage: 10,
        id: "",
        checklistId: "",
        formName: "",
        formSearchKey: "",
        pendencyCreated: "",
        pendencyDescription: "",
        dateCreateBegin: "",
        dateCreateEnd: "",
        exportType: "",
        templateId: "",
        pendencyStatusId: 90104,
        pendencyPriorityId: 0,
        saveFilter: true,
      };
      if (this.tableFilters.saveFilter) {
        this.filtersSave(this.tableFilters);
      }
    },
    async filtersGet() {
      this.isLoadingFilters = true;
      return this.$apiChecklist
        .get("/pendencies/getPendenciesOpenedFilter/")
        .then((response) => {
          if (response.data.appliedFilters != null) {
            let model = JSON.parse(response.data.appliedFilters);
            this.tableFilters = model;
            this.tableFilters.saveFilter = response.data.saveFilter;
            this.filterDateApplied = response.data.filterDateApplied;
          }
          this.ensureFilterDefaults();
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
            }
          }
        })
        .finally(() => {
          this.isLoadingFilters = false;
          this.$forceUpdate();
        });
    },
    async filtersSave(filter) {
      let filters = {
        appliedFilters: JSON.stringify(filter),
        saveFilter: this.tableFilters.saveFilter,
        filterDateApplied: this.filterDateApplied,
      };
      this.$apiChecklist
        .post("/pendencies/pendenciesOpenedFilterSave/", filters)
        .then((response) => {
          this.tableFilters = JSON.parse(response.data.appliedFilters);
          this.tableFilters.saveFilter = response.data.saveFilter;
          this.filterDateApplied = response.data.filterDateApplied;
          this.ensureFilterDefaults();
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log("Error ");
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    init() {
      this.$refs.table.refresh();
    },
    refreshPage() {
      // if (this.eventTimer.eventTimerMiliseconds == 0) return;
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        callback([]);
      }

      this.lastRefreshTime = new Date();
      this.isBusy = true;
      let apiFilter = {
        currentPage: 1,
        perPage: (ctx.perPage = ctx.perPage),
        id: ctx.filter.id,
        checklistId: ctx.filter.checklistId,
        formName: ctx.filter.formName,
        formSearchKey: ctx.filter.formSearchKey,
        pendencyCreateDate: ctx.filter.pendencyCreated,
        pendencyCreatedAtBegin: ctx.filter.dateCreateBegin,
        pendencyCreatedAtEnd: ctx.filter.dateCreateEnd,
        pendencyDescription: ctx.filter.pendencyDescription,
        pendencyStatus: ctx.filter.pendencyStatusId,
        pendencyPriority: ctx.filter.pendencyPriorityId,
        paginationIdGreater: null,
        paginationIdLesser: this.paginationEnd,
      };
      this.$apiChecklist
        .post("/pendencies/pagination/list", apiFilter)
        .then((response) => {
          const items = response.data;
          this.isBusy = false;
          this.tableItems = items;
          callback(items);
          if (this.tableFilters.saveFilter) {
            this.filtersSave(this.tableFilters);
          }
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    async myProviderCount() {
      if (this.isLoadingFilters) {
        this.tableRowCount = 0;
      }
      let apiFilter = {
        currentPage: 1,
        perPage: this.tablePerPage,
        id: this.tableFilters.id,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        pendencyCreateDate: this.tableFilters.pendencyCreated,
        pendencyCreatedAtBegin: this.tableFilters.dateCreateBegin,
        pendencyCreatedAtEnd: this.tableFilters.dateCreateEnd,
        pendencyDescription: this.tableFilters.pendencyDescription,
        pendencyStatus: this.tableFilters.pendencyStatusId,
        pendencyPriority: this.tableFilters.pendencyPriorityId,
        paginationIdGreater: null,
        paginationIdLesser: this.paginationEnd,
      };
      console.log("apiFilter");
      console.log(apiFilter);
      this.$apiChecklist
        .post("/pendencies/pagination/count", apiFilter)
        .then((response) => {
          console.log(response);
          this.tableRowCount = response.data;
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableRowCount = 0;
          }
        });
    },
    exportPendency(ctx) {
      this.tableFilters.pendencyStatus = 90104;
      this.tableFilters.perPage = this.tablePerPage;
      this.tableFilters.currentPage = 1;
      this.$apiChecklist
        .request({
          url: "/v2/checklist/pendencyExport/",
          method: "POST",
          data: this.tableFilters,
          responseType: "arraybuffer",
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    homePage(currentPage) {
      this.tableCurrentPage = 1;
      this.paginationEnd = null;
      this.paginationEndList = [];
      this.$refs.table.refresh();
    },
    nextPage(currentPage) {
      if (this.tableItems) {
        if (this.tableItems.length > 0) {
          let nextPaginationId = this.tableItems[this.tableItems.length - 1].id;
          this.paginationEnd = nextPaginationId;
          this.paginationEndList.push(nextPaginationId);
        }
      }
      this.$refs.table.refresh();
    },
    prevPage(currentPage) {
      if (this.paginationEndList.length > 0) {
        this.paginationEndList.splice(this.paginationEndList.length - 1, 1);
      }
      if (this.paginationEndList.length > 0) {
        let nextPaginationId =
          this.paginationEndList[this.paginationEndList.length - 1];
        this.paginationEnd = nextPaginationId;
        this.$refs.table.refresh();
      } else {
        this.paginationEnd = null;
        this.$refs.table.refresh();
      }
    },
    contextChanged() {
      this.tableCurrentPage = 1;
      this.paginationEnd = null;
      this.paginationEndList = [];
      this.myProviderCount();
    },
  },
  watch: {
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>
<style scoped>
.vertical-align {
  vertical-align: bottom !important;
}
.left {
  margin-left: 0px !important;
}
</style>
